import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import studyClasses from './studyStyles';
import { SRLWrapper } from "simple-react-lightbox";

const images = [
    { id: '1', imageName: 'casestudy-screenshot-1.jpg' },
  ];
  
  
  
  const options = {
    buttons: {
      backgroundColor: 'rgba(30,30,36,0.8)',
      iconColor: 'rgba(255, 255, 255, 0.8)',
      iconPadding: '10px',
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
      size: '40px'
    }, 
    thumbnails: {
        showThumbnails: false
      },
    settings: {
      autoplaySpeed: 3000,
      boxShadow: 'none',
      disableKeyboardControls: false,
      disablePanzoom: true,
      disableWheelControls: false,
      hideControlsAfter: 3000,
      lightboxTransitionSpeed: 0.3,
      lightboxTransitionTimingFunction: 'linear',
      overlayColor: 'rgba(30, 30, 30, 0.9)',
      slideAnimationType: 'fade',
      slideSpringValues: [300, 50],
      slideTransitionSpeed: 0.6,
      slideTransitionTimingFunction: 'linear',
      usingPreact: false
    }
  };
  

function StudyApproach() {
  const globalClasses = globalUseStyles()
  const studyStyles = studyClasses()
  return (
    <ThemeProvider theme={theme}>
        <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
            <Grid className={globalClasses.containerSmall} container >
                <Grid item xs={12} sm={12} md={3} container>
                  <SRLWrapper options={options}>
                
                  { images.map(image => 
                        <Grid  item xs={12} md={12} key={image.id}>
                          <Button className={studyStyles.buttonImageGallery}>
                            <img className={studyStyles.imageGallery} src={`/images/${image.imageName}`} alt=""/>
                    
                          </Button>
                        </Grid>
                      )}
                  </SRLWrapper>
                </Grid>
                
                <Grid item xs={false} md={1}  />
                <Grid item xs={12} md={8}  >
                    <Typography variant="subtitle1">How We Did It</Typography>
                    <Typography variant="h2">Our Approach</Typography>
                    <Typography variant="body1">We focused on developing a wholistic case management system that will enable RCI to manage their existing programs and data, as well as expand to new programs, services and data collection in a self-service manner. We don’t didn’t want RCI relying on the technical development team for each update. – instead, the Instead, our strategy has been worked to allow and allowed them to take this system and run with it. To do that, we needed to research RCI’s current needs as well as their vision for the future, and to develop a forward lookingforward-looking digital strategy for the application.  </Typography>
                </Grid>
                <Grid item xs={12} container className={globalClasses.containerTopPaddingSm} >
                    <Grid item xs={12} md={3}  >
                    <Typography className={globalClasses.topBottomSpacingMb} variant="h4">1. Data-Driven Decision Making</Typography>
                    </Grid>
                    <Grid item xs={false} md={1} />
                    <Grid item xs={12} md={8}  >
                        <Typography variant="body1">We researched the business processes and needs of the RCI staff and leadership, both in terms of their current processes and their vision for the future of the organization. We especially  focused especially on what their data needs would be to understand both how the new application would be used, as well as measure outcomes for caregivers.</Typography>
                        <Typography variant="body1"> We also researched the experience that the RCI coaches, those who work directly with caregivers to administer the programs and collect data, have with the program. The goal was to get a firm understanding of their journey with caregivers – both to learn what is rewarding and easy, and what is challenging or difficult about working with caregivers and administering the RCI program. From there, we were able to understand how to design the system to facilitate the best experience possible for coaches using the application, with the goal of reducing overhead and retaining qualified coaches within the program. </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} container className={globalClasses.containerTopPaddingSm} >
                    <Grid item xs={12} md={3}  >
                    <Typography className={globalClasses.topBottomSpacingMb} variant="h4">2. Design Founded on Research </Typography>
                    </Grid>
                    <Grid item xs={false} md={1}  />
                    <Grid item xs={12} md={8}  >
                        <Typography variant="body1">With our new renewed understanding of RCI’s goals and the coachinges experience, we were able to develop business and user centered requirements for the system and develop them into interactive prototypes. We shared designs with RCI staff and coaches on an ongoing basesbasis to get feedback as the prototypes developed -, ensuring that workflows, interactions, and designs were meeting the end users needs.  </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} container className={globalClasses.containerTopPaddingSm} >
                    <Grid item xs={12} md={3}  >
                    <Typography className={globalClasses.topBottomSpacingMb} variant="h4">3. Sprint Based Development</Typography>
                    </Grid>
                    <Grid item xs={false} md={1}  />
                    <Grid item xs={12} md={8}  >
                        <Typography variant="body1">With our vision for the system aligned, we were able to start sprint-based development. User stories were written and prioritized prior to each sprint, and developers were tasked with writing technical tasks that met the users’ needs and followed the prototype’s designs. Ongoing Q/A testing ensured that each release met the user story’sies goals, and that RCI would be happy with the results.  </Typography>
                    </Grid>
                </Grid>     
            </Grid>
        </Container>
    </ThemeProvider>
  );
};

export default StudyApproach;